import { gql } from '@apollo/client';

export const UPDATE_RESOURCE = gql`
  mutation UpdateResource($input: ResourceApiRequestInput!) {
    updateResource(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export interface UpdateResourceInput {
  id: number;
  code: string;
  name: string;
  type: string; // "MENU" | "BUTTON"
  parentId: number;
  description?: string | null;
}

export interface UpdateResourceResponse {
  updateResource: {
    success: boolean;
    message: string;
    messageCode?: string | null;
    data?: { id?: number | string | null } | null;
  };
}

export interface UpdateResourceVariables {
  input: UpdateResourceInput;
}

